import React from 'react'
import { CheckBox } from '..';

const ColCheckBox = ( { id, arrChecked = [], setArrChecked = ()=>{} } ) => {

  const verifyCheck = (arrChecked, value) => {

    let newArrChecked = [...arrChecked];
    let indexSelect = newArrChecked.indexOf(value);
    
    if (indexSelect < 0) {
      newArrChecked.push(value)
    } else {
      newArrChecked.splice(indexSelect, 1)
    }
    
    return newArrChecked;
  }

  const handleCheck = () => {
    setArrChecked( verifyCheck(arrChecked, id) );
  }

  return (
    <CheckBox 
      clicked={ arrChecked && (arrChecked.indexOf(id) >= 0) } 
      onClick={ handleCheck }
    />
  )
};

export default ColCheckBox;